import Table from "/src/components/table";
import withheldDestinationService from "/src/features/supervision/withheldDestinations/services/withheldDestinationService";
import { formatDateWithoutSeconds } from "/src/utils/dateWithoutSeconds";
import "../../WithheldDestinations.css";

// Each outcome named on its own: anything the server may come to send back that is not one of
// the two is shown as it stands rather than folded into the other.
const outcomes = {
    cancelled: { label: "Cancelled", title: "Nobody was left to reach, the job never went out" },
    reduced: { label: "Reduced", title: "The job went out to the other recipients" },
};

function outcome(value) {
    const known = outcomes[value];

    if (!known) {
        return value || "-";
    }

    return (
        <span className={`withheld-outcome withheld-outcome--${value}`} title={known.title}>
            {known.label}
        </span>
    );
}

function WithheldDestinationsTable() {
    const cells = [
        { column: "Destination", name: "destination" },
        { column: "Kind", name: "destination_kind", show: (value) => <span className="withheld-kind">{value}</span> },
        { column: "Bot", name: "bot.name", show: (value) => value || "-" },
        { column: "Job type", name: "bot_job_type", show: (value) => <span className="withheld-job-type">{value}</span> },
        { column: "Outcome", name: "outcome", show: (value) => outcome(value) },
        // No sort header: the client sorts only the pages already scrolled in, while the server
        // always answers most recent first -- a partial reorder would read as the whole truth.
        { column: "Withheld at", name: "withheld_at", show: (value) => formatDateWithoutSeconds(value) },
    ];

    const filters = [{ type: "input", placeholder: "Destination", name: "destination" }];

    // No action: a withholding is an event that already happened, and nothing undoes it. Writing
    // to this person again goes through lifting their line in the opt-out registry.
    return (
        <Table
            name="withheld destination"
            cells={cells}
            api={withheldDestinationService.getAll}
            actions={[]}
            buttons={[]}
            filters={filters}
        />
    );
}

export default WithheldDestinationsTable;
